import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { X } from 'lucide-react';

interface GlassPillProps {
  text: string;
  onRemove: () => void;
}

export function GlassPill({ text, onRemove }: GlassPillProps) {
  const reduce = useReducedMotion();
  return (
    <motion.span
      initial={{ opacity: 0, scale: reduce ? 1 : 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: reduce ? 1 : 0.8 }}
      transition={{ duration: 0.2, ease: [0.24, 1.34, 0.38, 1] }}
      className="inline-flex items-center gap-2 rounded-full border border-line bg-wash px-4 py-2 text-sm text-ink"
    >
      {text}
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${text}`}
        className="rounded-full p-0.5 text-ink-3 transition-colors hover:bg-wash hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </motion.span>
  );
}
